// import Swiper, { Navigation, Pagination } from 'swiper';
// Swiper.use([Navigation, Pagination]);

const promoSlider = new Swiper(".js-promoSlider .swiper-container", {
	direction: 'vertical',
	loop: true,
	touchRatio: 0.3,
	speed: 750,
	autoplay: {
		delay: 3000,
		disableOnInteraction: false
	},
	allowTouchMove: false,
	loopPreventsSlide: false,
	on: {
		init: function(swiper) {
			$('.js-promoSlider').find('.swiper-slide').css('transition-duration', `${this.passedParams.speed}ms`);
		},
		transitionStart: function() {
			let currentSlide = $('.js-promoSlider').find('.swiper-slide-prev');
			currentSlide.addClass('stay');
			setTimeout(()=>currentSlide.addClass('hide'), this.passedParams.speed / 3)
		},
		transitionEnd: function(swiper) {
			let currentSlide = $('.js-promoSlider').find('.swiper-slide-prev');
			currentSlide.removeClass('stay');
			setTimeout(()=>currentSlide.removeClass('hide'), this.passedParams.speed / 2)
		}
	}
});

const promoSlider2 = new Swiper(".js-promoSlider-2 .swiper-container", {
	direction: 'vertical',
	loop: true,
	touchRatio: 0.3,
	speed: 1000,
	autoplay: {
		delay: 1650,
		disableOnInteraction: false
	},
	allowTouchMove: false,
	loopPreventsSlide: false,
	on: {
		init: function(swiper) {
			$('.js-promoSlider-2').find('.swiper-slide').css('transition-duration', `${this.passedParams.speed}ms`);
		},
		transitionStart: function() {
			let currentSlide = $('.js-promoSlider-2').find('.swiper-slide-prev');
			currentSlide.addClass('stay');
			setTimeout(()=>currentSlide.addClass('hide'), this.passedParams.speed / 3)
		},
		transitionEnd: function(swiper) {
			let currentSlide = $('.js-promoSlider-2').find('.swiper-slide-prev');
			currentSlide.removeClass('stay');
			setTimeout(()=>currentSlide.removeClass('hide'), this.passedParams.speed / 2)
		}
	}
});